import Swal from 'sweetalert2';
import api from './api';

// Login do admin da plataforma exige o código de verificação enviado por e-mail
export const confirmTwoFactor = async (challengeToken, message) => {
  const result = await Swal.fire({
    title: 'Verificação em duas etapas',
    text: message || 'Digite o código enviado para o seu e-mail.',
    input: 'text',
    inputAttributes: { maxlength: '6', inputmode: 'numeric', autocomplete: 'one-time-code' },
    showCancelButton: true,
    confirmButtonText: 'Verificar',
    cancelButtonText: 'Cancelar',
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    preConfirm: async (code) => {
      try {
        const response = await api.post('/login/2fa', { challenge_token: challengeToken, code });
        return response.data;
      } catch (error) {
        Swal.showValidationMessage(error.response?.data?.message || 'Falha na verificação.');
        return false;
      }
    },
  });

  if (!result.isConfirmed) {
    throw new Error('Verificação cancelada. Faça login novamente.');
  }
  return result.value;
};
